import { nanoid } from "nanoid";
import HoldingTransaction from "./HoldingTransaction";

export default class Holding {
	constructor() {
		this.Id = nanoid(6);
		this.HoldingName = null;
		this.RegisteredOwner = null;
		this.HoldingIdentificationNumber = null;
		this.HoldingTransactions = [new HoldingTransaction()]
		this.NumberOfShares = null;
		this.documentList = [];
		this.showFileUpload = true;
	}
}
